import { isObeeLogic } from '../../utils/constants';
import { formatTimeFromInt } from '../../utils/helpers';
import { PREVIEW_MOCK_DATA, isPreviewMode } from '../../utils/previewMode';
import { makeGenericApiAction } from './shared/helpers';

export const fetchPaymentSettingsAction = (data) => (dispatch) => {
  // Eatclub doesn't need to fetch payment settings
  if (!isObeeLogic) {
    return;
  }

  if (isPreviewMode()) {
    dispatch({
      type: 'FETCH_PAYMENT_SETTINGS_SUCCESS',
      payload: PREVIEW_MOCK_DATA.paymentSettings,
    });
    return;
  }

  // const request = (variables) => graphQLQuery(obeePaymentSettingsByCriteria, variables);

  // makeApiAction(
  //   'FETCH_PAYMENT_SETTINGS',
  //   request,
  //   data,
  //   'obeePaymentSettingsByCriteria',
  //   'An error occurred while retrieving the payment settings.',
  //   dispatch,
  //   null,
  //   null,
  //   false,
  //   true,
  // );

  // Use new generic request endpoint for fetching payment settings, as transaction fees are not included in the Graphql schema
  makeGenericApiAction({
    action: 'FETCH_PAYMENT_SETTINGS',
    model: 'obeePaymentSettingsByCriteria',
    errorMessage: 'an error occurred while cancelling the booking.',
    dispatch,
    method: 'get',
    path: 'payments/getGenericPaymentSettings',
    payload: {
      date: data?.paymentSettings?.date,
      time: formatTimeFromInt(data?.paymentSettings?.time, 'HH:mm:ss'),
      size: data?.paymentSettings?.size,
      public: 1,
      area_id: data?.paymentSettings?.areaId,
    },
  });
};

/**
 * Fetch payment setting
 */
export const fetchPaymentSettingsByIdAction = (paymentSettingId) => async (dispatch) => {
  if (isPreviewMode()) {
    dispatch({
      type: 'FETCH_PAYMENT_SETTINGS_SUCCESS',
      payload: PREVIEW_MOCK_DATA.paymentSettings,
    });
    return;
  }

  makeGenericApiAction({
    action: 'FETCH_PAYMENT_SETTINGS',
    model: 'paymentSettings',
    dispatch,
    method: 'get',
    path: `payments/getPaymentSettingsByID/${paymentSettingId}`,
    payload: null,
  });
};
